import { useEffect, useState } from 'react';
import { debounce } from 'lodash';
import { buildListParams } from '../../dataHandlers/queryParams';

const usePartnerFilters = ({ defaultQuery = {}, searchOnChange = false }) => {
  const [pagination, setPagination] = useState({ page: 0, size: 10 });
  const [searchTerm, setSearchTerm] = useState('');
  const [appliedSearch, setAppliedSearch] = useState('');

  const activeSearch = searchOnChange ? searchTerm.trim() : appliedSearch.trim();

  const buildQuery = () => {
    const filters = { ...defaultQuery };
    if (activeSearch) {
      filters.search = activeSearch;
    }

    return buildListParams(pagination, filters);
  };

  const [currentQuery, setCurrentQuery] = useState(buildQuery());

  useEffect(() => {
    setCurrentQuery(buildQuery());
  }, [pagination, appliedSearch]);

  useEffect(() => {
    if (!searchOnChange) return;

    const handler = debounce(() => {
      setPagination((prev) => ({ ...prev, page: 0 }));
      setCurrentQuery(buildQuery());
    }, 500);

    handler();
    return () => handler.cancel();
  }, [searchTerm]);

  useEffect(() => {
    if (!searchOnChange) return;

    setCurrentQuery(buildQuery());
  }, [pagination]);

  const handleSearchChange = (value) => setSearchTerm(value ?? '');

  const handlePaginationChange = (page, limit) => setPagination({ page: page, size: limit });

  const handleSearchKeyDown = (event) => {
    if (event.key !== 'Enter' || searchOnChange) return;

    setAppliedSearch(searchTerm.trim());
    setPagination((prev) => ({ ...prev, page: 0 }));
  };

  return {
    searchTerm,
    currentQuery,
    pagination,
    handleSearchChange,
    handleSearchKeyDown,
    handlePaginationChange,
  };
};

export default usePartnerFilters;
